import { OtherIcon, PlaneIcon, ShipIcon, TrainIcon, TruckIcon, WaterWavesIcon } from "../../../../../../assets/icons";
import { DataChart } from "../../../../../../components/charts/graph/PieChartDistributionType";
import { TransportTypesColors } from "../../../../../../theme/themeValues";

type TkmSplitItem = {
	haulageId: number;
	haulageLabel: string;
	tkm: {
		measure: string;
		value: number;
		percentage: number;
	};
};

export const mapTkmSplitToDataChart = (items: TkmSplitItem[]): DataChart[] =>
	items.map((item) => ({
		id: item.haulageId,
		label: item.haulageLabel,
		value: item.tkm.value,
		percent: Number(item.tkm.percentage.toFixed(2)),
		icon: getTransportTypeIcon(item.haulageId),
	}));

export const mapTkmSplitToColors = (items: TkmSplitItem[]) =>
	items.map((item) => getTransportTypeColor(item.haulageId));

export const getTransportTypeColor = (haulageId: number) => {
	switch (haulageId) {
		case 1:
			return TransportTypesColors.LightRoad;
		case 2:
			return TransportTypesColors.LightTrain;
		case 3:
			return TransportTypesColors.LightShip;
		case 4:
			return TransportTypesColors.LightAir;
		case 5:
			return TransportTypesColors.LightWaterWaves;
		default:
			return TransportTypesColors.LightOther;
	}
};

export const getTransportTypeIcon = (haulageId: number) => {
	switch (haulageId) {
		case 1:
			return <TruckIcon sx={{ color: TransportTypesColors.LightRoad }} />;
		case 2:
			return <TrainIcon sx={{ color: TransportTypesColors.LightTrain }} />;
		case 3:
			return <ShipIcon sx={{ color: TransportTypesColors.LightShip }} />;
		case 4:
			return <PlaneIcon sx={{ color: TransportTypesColors.LightAir }} />;
		case 5:
			return <WaterWavesIcon sx={{ color: TransportTypesColors.LightWaterWaves }} />;
		default:
			return <OtherIcon sx={{ color: TransportTypesColors.LightOther }} />;
	}
};
